export const LOG_RELATIONS = {
  CLIENT: 'client',
  TICKET: 'ticket',
};

export const TICKET_TYPES = {
  COMMON_QUESTION: 'common_question',
  TOUR_SELECTION: 'tour_selection',
  UNKNOWN: 'unknown',
  UPDATING: 'updating',
  HOTLINE: 'hotline',
};

// Тип сообщения
export const CLIENT_LOG_TYPES = {
  CALL: 'call',
  EMAIL: 'email',
  MESSAGE: 'message',
  NOTE: 'note',
  SMS: 'sms',
  MESSAGE_GROUP: 'message_group',
  MANAGER_EMAIL: 'manager_email',
};

export const CLIENT_LOG_TOOLTIPS = {
  [CLIENT_LOG_TYPES.CALL]: 'Звонки',
  [CLIENT_LOG_TYPES.EMAIL]: 'Письма',
  [CLIENT_LOG_TYPES.MESSAGE]: 'Мессенджеры',
  [CLIENT_LOG_TYPES.NOTE]: 'Заметки',
  [CLIENT_LOG_TYPES.SMS]: 'СМС',
  [CLIENT_LOG_TYPES.MESSAGE_GROUP]: 'Неизвестный тип',
  [CLIENT_LOG_TYPES.MANAGER_EMAIL]: 'Автописьма',
};

export const TICKET_LOG_TYPES = {
  SYSTEM: 'system',
  USER: 'user',
  NOTE: 'note',
  TASK: 'task',
  DEBUG: 'debug',
  SYSTEM_AUTO: 'system_auto',
  SYSTEM_VIEW: 'system_view',
  SYSTEM_CHANGE: 'system_change',
  SYSTEM_DISPATCH: 'system_dispatch',
  USER_RATING: 'user_rating',
  TOUR_SELECTION: 'tour_selection',
  USER_CREATION_ACTION: 'user_creation_action',
};

export const TICKET_LOG_TOOLTIPS = {
  [TICKET_LOG_TYPES.SYSTEM]: 'Автоматические изменения',
  [TICKET_LOG_TYPES.USER]: 'Ручные изменения',
  [TICKET_LOG_TYPES.NOTE]: 'Заметки',
  [TICKET_LOG_TYPES.TASK]: 'Задачи',
  [TICKET_LOG_TYPES.DEBUG]: 'Технические логи',
  [TICKET_LOG_TYPES.SYSTEM_AUTO]: 'Начало работы с тикетом',
  [TICKET_LOG_TYPES.SYSTEM_VIEW]: 'Просмотры',
  [TICKET_LOG_TYPES.SYSTEM_CHANGE]: 'Прикрепление тега / заказа',
  [TICKET_LOG_TYPES.SYSTEM_DISPATCH]: 'Распределение',
  [TICKET_LOG_TYPES.USER_RATING]: 'Запрос NPS',
  [TICKET_LOG_TYPES.TOUR_SELECTION]: 'Подбор тура',
  [TICKET_LOG_TYPES.USER_CREATION_ACTION]: 'Создание тикета',
};

export const HIDDEN_LOG_TYPES = new Set([
  CLIENT_LOG_TYPES.MESSAGE_GROUP,
  TICKET_LOG_TYPES.DEBUG,
]);

export const SEARCH_CARD_TYPES = {
  CLIENTS: 'clients',
  ORDERS: 'orders',
  COMMUNICATION: 'communication',
  NOTES: 'notes',
  MESSAGES: 'messages',
};

export const MESSAGE_STATUS = {
  NONE: 'none',
  SENT: 'sent',
  RECEIVED: 'received',
  READ: 'read',
};

export const MESSENGER_TYPES = {
  INSTAGRAM: 'instagram',
  WHATSAPP: 'whatsapp',
  TELEGRAM: 'telegram',
  FACEBOOK_MESSENGER: 'facebook_messenger',
  FACEBOOK: 'facebook',
  VIBER: 'viber',
  MAIL: 'mail',
  VK: 'vk',
};

export const ALIGN = {
  AUTO: 'auto',
  SMART: 'smart',
  CENTER: 'center',
  END: 'end',
  START: 'start',
};

export const MANAGER_STATUSES = {
  AFTER_SERVICE: 'afterService',
  DND: 'dnd',
  IN_SERVICE: 'inService',
  OFFLINE: 'offline',
  ONLINE: 'online',
  READY: 'ready',
};
